import { useFormikContext } from "formik";
import React from "react";
import CommonTable from "../../../../candidates/Table";

export default function Candidate({
  isLoading,
  handleTableBodyData,
  headerData,
  handleViewClick,
}) {
  const { values } = useFormikContext();

  return (
    <CommonTable
      marginTop="0rem"
      data={values.resumes}
      columns={headerData}
      handleTableBodyData={(row) => handleTableBodyData(row)}
      loading={isLoading}
      loadingRowLength={3}
      handleRowClick={handleViewClick}
      customStyle={{
        "& .MuiTableRow-root": {
          cursor: "pointer",
        },
        "& .MuiTableRow-head": {
          cursor: "auto",
        },
      }}
    />
  );
}
